import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import Select from 'react-select';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs';
import { ThemeContext } from '../../../../../auth';
import * as Yup from 'yup';
import { axiosAuth } from '../../../../../api';


const validationSchema = Yup.object().shape({
    password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
});

function ModalTambahAkunPegawai({
    showTambahPegawai,
    setShowTambahPegawai,
    accessToken,
    retrieveAkun,
    listDivisi,
}) {

    const { theme } = useContext(ThemeContext);
    const [listRole, setListRole] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [selectedDivisi, setSelectedDivisi] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [position, setPosition] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [error, setError] = useState('');

    const divisiOptions = listDivisi.map(divisi => ({
        value: divisi.id,
        label: divisi.groupName,
    }));

    const handleSelectDivisi = selectedOption => {
        setSelectedDivisi(selectedOption);
    };

    const retrieveRole = () => {
        if (!selectedDivisi?.value) return;

        axiosAuth.get(`/api/roles?groupId=${selectedDivisi.value}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Bearer ${accessToken}`,
            },

        })
            .then(res => {
                setListRole(res.data.data || []);
            })
            .catch(err => {
                console.error(err);
            });
    };

    useEffect(() => {
        if (selectedDivisi?.value !== undefined) retrieveRole();
    }, [selectedDivisi?.value]);

    const roleOptions = (listRole || []).map(role => ({
        value: role.id,
        label: role.roleName,
    }));

    const handleSelectRole = selectedOption => {
        setSelectedRole(selectedOption);
    };

    const handleClose = () => {
        setShowTambahPegawai(false);
        setFirstName('');
        setLastName('');
        setUserName('');
        setEmail('');
        setPassword('');
        setSelectedDivisi(null);
        setSelectedRole(null);
        setPosition('')
    };

    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            backgroundColor: theme === 'light' ? '#212529' : '#FFFFFF',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };


    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular',
            textAlign: 'left'
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        })

    };


    const handleSubmit = async (event) => {

        event.preventDefault();

        setError('');

        try {
            await validationSchema.validate({ password });
            const data = {
                username: userName,
                firstName: firstName,
                lastName: lastName,
                email: email,
                password: password,
                roleId: selectedRole?.value,
                position: position
            };

            setIsSubmitting(true);
            setDisabled(true);

            try {
                const response = await axiosAuth.post('/api/auth/register', data, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil menambahkan Pegawai',
                    showConfirmButton: true,
                });

                handleClose();
                retrieveAkun();
                setIsSubmitting(false);
                setDisabled(false);

            } catch (err) {
                console.error(err);
                if (err.response?.status === 400) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...!',
                        text: `${err.response?.data.message}`,
                    })
                    setIsSubmitting(false);
                    setDisabled(false);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Terjadi kesalahan saat menambahkan Pegawai',
                    });
                    setIsSubmitting(false);
                    setDisabled(false);
                }
            } finally {
                setIsSubmitting(false);
                setDisabled(false);
            }
        } catch (err) {
            setError(err.message);
        }


    };


    return (
        <Modal
            show={showTambahPegawai}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Tambah Akun Pegawai
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='firstName'>Nama Depan*</Form.Label>
                        <Form.Control
                            id='firstName'
                            type="text"
                            disabled={disabled}
                            onChange={(e) => setFirstName(e.target.value)}
                            value={firstName}
                            required
                            style={formStyles.input}
                            placeholder='Masukkan nama depan'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='lastName'>Nama Belakang</Form.Label>
                        <Form.Control
                            id='lastName'
                            type="text"
                            disabled={disabled}
                            onChange={(e) => setLastName(e.target.value)}
                            value={lastName}
                            // required
                            style={formStyles.input}
                            placeholder='Masukkan nama belakang'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='username'>Username*</Form.Label>
                        <Form.Control
                            id='username'
                            type="text"
                            disabled={disabled}
                            onChange={(e) => setUserName(e.target.value)}
                            value={userName}
                            required
                            style={formStyles.input}
                            placeholder='Masukkan username'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='email'>Email*</Form.Label>
                        <Form.Control
                            id='email'
                            type="email"
                            disabled={disabled}
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            required
                            style={formStyles.input}
                            placeholder='Masukkan email'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='divisi'>Divisi*</Form.Label>
                        <Select
                            id='divisi'
                            options={divisiOptions}
                            required
                            value={selectedDivisi}
                            onChange={handleSelectDivisi}
                            styles={selectStyles}
                            placeholder='Pilih Divisi'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='role'>Role*</Form.Label>
                        <Select
                            id='role'
                            options={roleOptions}
                            required
                            value={selectedRole}
                            onChange={handleSelectRole}
                            isDisabled={disabled}
                            styles={selectStyles}
                            placeholder='Pilih Role'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='position'>Posisi*</Form.Label>
                        <Form.Control
                            id='position'
                            type="text"
                            disabled={disabled}
                            onChange={(e) => setPosition(e.target.value)}
                            value={position}
                            required
                            style={formStyles.input}
                            placeholder='Masukkan nama posisi'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" >
                        <Form.Label style={formStyles.label} htmlFor='passwordLogin'>Password*</Form.Label>
                        <Form.Control
                            id='password'
                            type={passwordShown ? "text" : "password"}
                            disabled={disabled}
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            style={formStyles.input}
                            placeholder='Masukkan password'
                            isInvalid={!!error}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        )}
                        <p className='mt-2' onClick={togglePassword} style={{ fontFamily: 'Poppins-Regular', cursor: 'pointer', maxWidth: '170px', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>{passwordShown ? "Hide" : "Show"} password <span >{passwordShown ? <BsEyeSlashFill size={20} /> : <BsEyeFill size={20} />} </span></p>
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !firstName ||
                                    !userName ||
                                    !email ||
                                    !selectedDivisi ||
                                    !selectedRole ||
                                    !password
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahAkunPegawai
